import { FunctionComponent } from 'react';
import { Card } from 'react-bootstrap';
import cn from 'classnames';
import styles from './CampaignCard.module.css';
import skeletonStyles from './CampaignCardSkeleton.module.css';

const CampaignCardSkeleton: FunctionComponent<{ className?: string }> = ({ className }) => {
    return (
        <Card bsPrefix={cn(styles.campaignCard, className)}>
            <Card.Header bsPrefix={styles.header}>
                <div className={cn(styles.headerCol, styles.titleCol)}>
                    <div className={cn(styles.image, 'shimmer-bg', skeletonStyles.skeletonIcon)}>
                        {/* Shimmer for icon */}
                    </div>
                    <div className={styles.content}>
                        <div className={cn('shimmer-bg', skeletonStyles.skeletonTitle)}></div>
                    </div>
                </div>
                <div className={cn(styles.headerCol, styles.optionCol)}>
                    <div className={cn(styles.option, 'shimmer-bg', skeletonStyles.skeletonOption)}>
                        {/* Shimmer for options/dropdown */}
                    </div>
                </div>
            </Card.Header>
            <Card.Body bsPrefix={styles.body}>
                <span className={cn('shimmer-bg', skeletonStyles.skeletonStatus)}>
                    {/* Shimmer for status */}
                </span>
                <div className={cn('shimmer-bg', skeletonStyles.skeletonTag)}></div>
            </Card.Body>
            <Card.Footer bsPrefix={styles.foorer}>
                <span className={cn(styles.label, skeletonStyles.skeletonDate)}>
                    <div className={cn('shimmer-bg', skeletonStyles.skeletonText)}></div>
                </span>
                <span className={cn(styles.label, skeletonStyles.skeletonUser)}>
                    <div className={cn('shimmer-bg', skeletonStyles.skeletonText)}></div>
                </span>
            </Card.Footer>
        </Card>
    );
};

export default CampaignCardSkeleton;
